const elements = {
  searchToggle: [...document.getElementsByClassName('js-search__toggle')],
};

function toggleHandler(e) {
  e.target.parentElement.classList.toggle('is-active');
  e.target.nextElementSibling.setAttribute('aria-hidden', !e.target.parentElement.classList.contains('is-active'));
}

function init() {
  if (elements.searchToggle.length) {
    elements.searchToggle.forEach(el => el.addEventListener('click', toggleHandler));
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/geneco/search/mando-ui.search.js